import { BaseValue, StorableType, ValidationArgs } from './validation'

export type UpdaterFn<TValue> = (prev: TValue | null) => TValue | null

export const isUpdaterFn = <TValue>(
  value: TValue | UpdaterFn<TValue> | null,
): value is UpdaterFn<TValue> => typeof value === 'function'

export type BaseStorageHookOptions<TType extends StorableType, TValue extends BaseValue<TType>> = {
  type: TType
  validation?: ValidationArgs<TType, TValue>
  defaultValue?: NoInfer<TValue>
}

// TODO:
// Backport from TS 5.4
// Удалить после обновления TS
export type NoInfer<T> = [T][T extends any ? 0 : never]
